import { Link, Text } from "@chakra-ui/react";
import { Trans } from "react-i18next";
import { BLUE_300 } from "styles/theme";
import { IContactFootnoteProps } from "./interfaces";

/** Centered footnote with a mailto link, styled for the glass error/system pages. */
export function ContactFootnote(props: IContactFootnoteProps) {
  const { i18nKey, defaultText, email, testId } = props;
  const mailLink = <Link href={`mailto:${email}`} color={BLUE_300} fontWeight="600" _hover={{ color: "white", textDecoration: "none" }} />;

  return (
    <Text data-testid={testId} textAlign="center" textStyle="body" color="whiteAlpha.800">
      <Trans
        i18nKey={i18nKey}
        defaults={defaultText}
        components={{ contactLink: mailLink }}
      />
    </Text>
  );
}
